import { useMemo } from "react";
import * as FlagIcons from "country-flag-icons/react/3x2";
import type { ComponentType, SVGProps } from "react";

export type CountryOption = {
  code: string;
  name: string;
  Flag: ComponentType<SVGProps<SVGSVGElement>> | null;
};

const displayNames =
  typeof Intl !== "undefined" && typeof Intl.DisplayNames !== "undefined"
    ? new Intl.DisplayNames(["en"], { type: "region" })
    : null;

const countryOptions: CountryOption[] = Object.keys(FlagIcons)
  .filter((code) => /^[A-Z]{2}$/.test(code))
  .map((code) => ({
    code,
    name: displayNames?.of(code) ?? code,
    Flag: (FlagIcons as Record<string, ComponentType<SVGProps<SVGSVGElement>> | undefined>)[code] ?? null
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const useCountryOptions = () => {
  return useMemo(() => countryOptions, []);
};
